import React from "react";

// state
import { ICreateBlog, ICreateErrorBlog } from "../../../store/types/blog";

const useCreateBlog = () => {
  const [data, setData] = React.useState<ICreateBlog>({
    title: "",
    feature_image: "",
    slug: "",
    excerpt: "",
    body: "",
    is_published: false,
    category_id: 0,
  });

  const [error, setError] = React.useState<ICreateErrorBlog>({
    feature_image: "",
    title: "",
    slug: "",
    excerpt: "",
    body: "",
    category_id: "",
  });

  const onValidate = () => {
    const requiredMessage = "error: this field is required" as const;
    const errors: ICreateErrorBlog = {
      feature_image: data.feature_image ? "" : requiredMessage,
      title: data.title.trim() ? "" : requiredMessage,
      slug: data.slug.trim() ? "" : requiredMessage,
      excerpt: data.excerpt.trim() ? "" : requiredMessage,
      body: data.body.trim() ? "" : requiredMessage,
      category_id: data.category_id > 0 ? "" : requiredMessage,
    };
    setError(errors);
    return Object.values(errors).every((message) => !message);
  };

  return {
    data,
    error,
    setData,
    setError,
    onValidate,
  };
};

export default useCreateBlog;
